<template>
  <div class="item-finacnce-daly">
    <div class="left">
      <div class="title">
        <div class="type" :style="{color:payTypeNameColor}">{{ payTypeName }}：</div>
        <div class="sn" v-if="orderSn">{{ orderSn }}</div>
      </div>
      <div class="content">{{ date }}</div>
    </div>
    <div class="right" :class="this.operationType==1?'black':'red'">
      <div class="price">￥{{ amount }}</div>
      <div class="type" :style="{color:statusColor}">{{status == 0?'未入账':status == 1?'已入账':status == 2?'已取消':status == 3?'已申请':status == 4?'已分账':''}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinaceItemDaly",
  props: {
    payType: null,
    orderSn: String,
    date: String,
    amount: Number,
    operationType:Number,
    status:null
  },
  computed: {
    evenDate: function () {
      let result = 1;
      let year = new Date(this.date).getFullYear();
      let mounth = new Date(this.date).getMonth() + 1;
      let day = new Date(this.date).getDate();
      result = `${year}-${mounth}-${day}`;
      return result;
    },
    payTypeName:function(){
      let name
      switch(this.payType){
        case 60:
          name = '喇叭押金'
          break;
        case 61:
          name = '扫码收银'
          break;
        case 62:
          name = '门店订单'
          break;
        case 63:
          name = '门店优惠'
          break;
        case 68:
          name = '支付手续费补贴'
          break;
        case 80:
          name = '喇叭押金返还'
          break;
        case 81:
          name = '扫码收银取消'
          break;
        case 82:
          name = '门店订单取消'
          break;
        case 84:
          name = '门店优惠'
          break;
        case 5:
          name = '微信提现'
          break;
        case 35:
          name = '微信提现取消'
          break;
        case 67:
          name = '推荐奖励'
          break
        case 87:
          name = '推荐奖励取消'
          break
        default:
          name = '未知类型'
      }
      return name
    },
    payTypeNameColor:function(){
      let color
      switch(this.payType){
        case 60:
          color = '#333333'
          break;
        case 61:
          color = '#333333'
          break;
        case 62:
          color = '#333333'
          break;
        case 63:
          color = '#333333'
          break;
        case 80:
          color = '#333333'
          break;
        case 81:
          color = '#333333'
          break;
        case 82:
          color = '#333333'
          break;
        case 84:
          color = '#333333'
          break;
        case 5:
          color = '#333333'
          break;
        case 35:
          color = '#333333'
          break;
        case 67:
          color = '#C775DF'
          break
        case 68:
          color = '#009966'
          break
        case 87:
          color = '#C775DF'
          break
        default:
          color = '#333333'
      }
      return color
    },
  statusColor:function(){
      let color
      switch(this.status){
        case 0:
          color = '#AAAAAA'
          break;
        case 1:
          color = '#0074D9'
          break;
        case 2:
          color = '#FF4136'
          break;
        case 3:
          color = '#3D9970'
          break;
        case 4:
          color = '#FF851B'
          break;
        default:
          color = '#d1d1d1'
      }
      return color
    }
  },
  create(){
      
  },
  mounted() {

  },
  methods: {},
};
</script>

<style lang="scss">
.item-finacnce-daly {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  min-height: 60px;
  align-items: center;
  box-shadow: 1px 1px 3px #dedede;
  .left{
    text-align: left;
    .title{
      display: flex;
      align-items: center;
      font-size: .9rem;
      font-weight: 400;
      .type{
        font-weight: 600;
      }
    }
    .content{
      margin-top: 6px;
      font-size: .9rem;
    }
  }
  .right{
    min-width: 4rem;
    font-size: 1rem;
    font-weight: bold;
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .type{
      font-size: .8rem;
      color: #b1b1b1;
    }
  }
  .red{
    color: #bb0000;
  }
  .black{
    color: #333333;
  }
}
</style>
